import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_INVOICE_FREQUENCIES } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const InvoiceFrequencies = {
  namespaced: true,
  state: buildInitialState({
    invoiceFrequenciesList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setInvoiceFrequencies: (state, InvoiceFrequencies) => {
      state.invoiceFrequenciesList = InvoiceFrequencies
    }
  },
  actions: {
    getInvoiceFrequencies: ({ commit }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_INVOICE_FREQUENCIES, parameters: filters })
        .then(json => json.data)
        .then(InvoiceFrequencies => {
          commit('updateStatus', { status: COMPLETE })
          commit('setInvoiceFrequencies', InvoiceFrequencies)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default InvoiceFrequencies
